import React, { PropsWithChildren } from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Form } from '@/components/ui/form';

import ResponsibleFormStepView from './view';
import {
  ICompanyResponsibleFormSchema,
  companyResponsibleSchema,
} from './schema';

interface IProps extends PropsWithChildren {
  defaultValues?: DefaultValues<ICompanyResponsibleFormSchema>;
  onSubmit: SubmitHandler<ICompanyResponsibleFormSchema>;
}

const ResponsibleFormStep: React.FC<IProps> = ({
  defaultValues,
  onSubmit,
  children,
}) => {
  const form = useForm<ICompanyResponsibleFormSchema>({
    defaultValues,
    resolver: zodResolver(companyResponsibleSchema),
  });

  return (
    <Form {...form}>
      <ResponsibleFormStepView
        control={form.control}
        isLoading={form.formState.isSubmitting}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        {children}
      </ResponsibleFormStepView>
    </Form>
  );
};

export default ResponsibleFormStep;
